import { createSlice, PayloadAction, current } from "@reduxjs/toolkit";
import { FlashbarProps } from "@cloudscape-design/components-themed";
import { store } from "../../app/store";
import { getMessage, Messages } from "./messages";

export interface NotificationsState {
  id: number;
  notifications: FlashbarProps.MessageDefinition[];
}

const initialState = {
  id: 0,
  notifications: [] as FlashbarProps.MessageDefinition[],
} as NotificationsState;

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addNotification: (
      state,
      action: PayloadAction<{
        msgId: keyof Messages;
        msgArgs: string[];
      }>
    ) => {
      const { msgId, msgArgs } = action.payload;
      const { level, label } = getMessage(msgId, ...msgArgs);

      const { id } = current(state);
      const addedId = id + 1;
      const addedNotification: FlashbarProps.MessageDefinition = {
        type: level,
        content: label,
        dismissible: true,
        id: String(addedId),
        onDismiss: () => store.dispatch(removeNotification(addedId)),
      };

      state.id = addedId;
      state.notifications = [...state.notifications, addedNotification];
    },
    removeNotification: (state, action: PayloadAction<number>) => {
      state.notifications = [
        ...state.notifications.filter(
          (notification) => notification.id !== String(action.payload)
        ),
      ];
    },
  },
});

export const { addNotification, removeNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
